import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import HeaderGeneral from "../../../components/Header/HeaderGeneral";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import SusunanKeluargaModal from "./Components/SusunanKeluargaModal";
import SusunanKeluargaOrangTuaTable from "./Components/SusunanKeluargaOrangTuaTable";
import SusunanKeluargaTable from "./Components/SusunanKeluargaTable";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import useFetchAllSusunanKeluarga from "../../../api/effects/queries/SusunanKeluarga/useFetchAllSusunanKeluarga";
import useFetchAllSusunanKeluargaOT from "../../../api/effects/queries/SusunanKeluarga/useFetchAllSusunanKeluargaOT";

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));
const ButtonGrid = styled(Grid)(({ theme }) => ({
  paddingRight: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));

export default function SusunanKeluargaPage() {
  const [modalState, setModalState] = useState(false);
  const [typeKeluarga, setTypeKeluarga] = useState("");
  const [editingId, setEditingId] = useState<number | undefined>(undefined);
  const { data: keluargaData, isLoading: isKeluargaLoading } = useFetchAllSusunanKeluarga();
  const { data: keluargaOTData, isLoading: isKeluargaOTLoading } = useFetchAllSusunanKeluargaOT();

  const handleCloseModal = () => {
    setTypeKeluarga("");
    setModalState(false);
    setEditingId(undefined);
  };

  const handleOpenModal = () => {
    setTypeKeluarga("");
    setModalState(true);
  };

  const handleOpenModalOT = () => {
    setTypeKeluarga("OT");
    setModalState(true);
  };
  const handleEditOrangTua = (id: number) => {
    handleOpenEditModal(id, "OT");
  };
  const handleEditKeluarga = (id: number) => {
    handleOpenEditModal(id, "");
  };
  const handleOpenEditModal = (id: number, type: string) => {
    setEditingId(id);
    setTypeKeluarga(type);
    setModalState(true);
  };
  const allFamilyMembers = [...(keluargaData || []), ...(keluargaOTData || [])];
  const isApplicantAlreadyExists = allFamilyMembers.some(
    (member) => member.IS_APPLICANT && member.SUSUNAN_KELUARGA_ID !== editingId
  );

  // const [loading, setLoading] = useState(true);
  const pageIsLoading = isKeluargaLoading || isKeluargaOTLoading;

  // useEffect(() => {
  //   setLoading(false);
  // }, []);

  // if (loading) {
  //   return (
  //     <GridSkeleton justifyContent="center" alignItems="center">
  //       <SkeletonText variant="text" />
  //       <SkeletonTable variant="rectangular" />
  //     </GridSkeleton>
  //   );
  // }
  return (
    <Box>
      <SusunanKeluargaModal
        type={typeKeluarga}
        open={modalState}
        handleClose={handleCloseModal}
        ID={editingId}
        isApplicantAlreadyExists={isApplicantAlreadyExists}
      />
      <LoadingOverlay isLoading={pageIsLoading}>
        <TitleGrid container item xs={12} justifyContent="flex-start">
          <Typography variant="h5">
            Susunan Keluarga (Dari Orangtua, Saudara kandung, Termasuk Diri Saudara Sendiri)
          </Typography>
        </TitleGrid>
        <SusunanKeluargaOrangTuaTable onEdit={handleEditOrangTua} />
        <ButtonGrid container item xs={12} justifyContent="flex-end">
          <Button variant="contained" onClick={handleOpenModalOT}>
            Tambah Susunan Keluarga Dari Orang Tua
          </Button>
        </ButtonGrid>
        <TitleGrid container item xs={12} justifyContent="flex-start">
          <Typography variant="h5">
            Tambah Susunan Keluarga (Bagi yang Sudah Menikah)
          </Typography>
        </TitleGrid>
        <SusunanKeluargaTable onEdit={handleEditKeluarga} />
        <ButtonGrid container item xs={12} justifyContent="flex-end">
          <Button variant="contained" onClick={handleOpenModal}>
            Tambah Susunan Keluarga (Bagi yang Sudah Menikah)
          </Button>
        </ButtonGrid>
      </LoadingOverlay>
    </Box>
  );
}
